import LineAwardIcon from 'LuxKit/Icons/line/LineAwardIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'

const AWARD_ICON = <LineAwardIcon />

interface Props {
  message: string
}

/** Rebrand in-tile badge for a suggested/popular package option. */
function SuggestedPackagePromotionLabel({ message }: Props) {
  return (
    <PromotionLabel variant="premium" icon={AWARD_ICON}>
      {message}
    </PromotionLabel>
  )
}

export default SuggestedPackagePromotionLabel
